const apiFunction = (input, url, method) => {
  const { token, ...filteredData } = input;
  return {
    url,
    method,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: { ...filteredData },
  };
};

const URL = {
  url: process.env.REACT_APP_API_URL || "https://bayineriot.com",
  url3: "https://bayineriot.com/",
  url2: "",
};

/** Gösterim için IP: ::ffff:127.0.0.1 → 127.0.0.1 */
const formatDisplayIp = (ip) => {
  if (!ip || typeof ip !== "string") return ip || "";
  const s = ip.trim();
  if (s.startsWith("::ffff:")) return s.slice(7);
  return s;
};

/** E-posta gönderim hatası için kullanıcıya gösterilecek mesaj (SMTP geçici hata vb.) */
const EMAIL_SEND_USER_MESSAGE =
  "E-posta şu an gönderilemiyor. Lütfen birkaç dakika sonra tekrar deneyin.";

/**
 * Doğrulama kodu e-postası gönderilemediğinde UI'da gösterilecek mesajı döndürür.
 * @param {{ data?: { message?: string }, status?: number } | undefined} error - RTK/axios hata objesi
 * @param {string} [fallback] - Varsayılan mesaj
 */
const getEmailSendErrorMessage = (error, fallback = "Kod gönderilemedi.") => {
  const msg = error?.data?.message ?? "";
  const status = error?.data?.statusCode ?? error?.status;
  if (
    status === 503 ||
    msg.includes("E-posta şu an") ||
    /Mail command failed|454\s+4\.3\.0|Try again later/i.test(msg)
  ) {
    return EMAIL_SEND_USER_MESSAGE;
  }
  return msg || fallback;
};

export { apiFunction, URL, formatDisplayIp, getEmailSendErrorMessage };
